<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Výber lokality</div>
      </div>

      <div class="popup-block d-flex justify-content-start align-items-center" v-for="(region, index) in this.regionChoices" :key="index">
        <div class="checkboxWrapper pointer" @click="toggleWholeRegion(region.id)">
          <img
            v-if="hasWholeRegion(region.id)"
            alt=""
            class="nav-link-icon extrasmall filter-primary"
            loading="lazy" src="https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/692aede6bc96dc77105a6e88_checkiconsimple.svg"
          />
        </div>
        <div class="cta-email d-flex justify-content-between w-100">
          <span>{{ region.name }}</span>
          <span class="text-small bl-color pointer" @click="openDistrictPickerPopUp(region.id)">VYBRAŤ OKRESY</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BrokerRegionPickerPopUp",
  props: {
    payload: Array,
    metaData: Object
  },
  computed: {
    ...mapGetters({
      formByType: "formStore/getFormByType"
    }),

    regionChoices() {
      return this.formByType("regionChoices");
    },
    districtChoices() {
      return this.formByType("districtChoices");
    }
  },
  mounted() {
    this.districtsServed = this.payload;
  },
  methods: {
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    toggleWholeRegion(regionId) {
      const regionDistrictIds = this.districtChoices
        .filter(d => d.region === regionId)
        .map(d => d.id);

      const allSelected = regionDistrictIds.every(id =>
        this.districtsServed.includes(id)
      );

      if (allSelected) {
        for (let i = this.districtsServed.length - 1; i >= 0; i--) {
          if (regionDistrictIds.includes(this.districtsServed[i])) {
            this.districtsServed.splice(i, 1);
          }
        }
      } else {
        for (const id of regionDistrictIds) {
          if (!this.districtsServed.includes(id)) {
            this.districtsServed.push(id);
          }
        }
      }
    },

    openDistrictPickerPopUp(regionId) {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: {
          region: regionId,
          districtsServed: this.districtsServed
        },
        component: "BrokerDistrictPickerPopUp",
        rules: ["single"],
      });
    },

    hasWholeRegion(regionId) {
      for (const districtChoice of this.districtChoices) {
        if (districtChoice.region === regionId && !this.districtsServed.includes(districtChoice.id)) {
          return false;
        }
      }

      return true;
    },
  },
  data: () => ({
    districtsServed: []
  })
}
</script>

<style scoped>

</style>